import React, { useState } from "react";
import { FaCalendarDay, FaFrown, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/QuestionerModal.css";
import CommonButton from './CommonButton';
import CustomFormGroup from "./CustomFormGroup";
import LanguageToggle from './LanguageToggle';
import MessageModal from './MessageModal';

const QuestionerModal = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [language, setLanguage] = useState("ID");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [touchedYear, setTouchedYear] = useState(false);

  const t = (id, en) => (language === 'ID' ? id : en);
  const questionsText = language === 'ID'
  ? [
      {id: 'A', desc: 'Yogi ODM Bhante Kondanna (KSN)'},
      {id: 'A', desc: 'Yogi Retret Bhante Kondanna (KSN)'},
      {id: 'B', desc: 'Volunteer KSN'},
      {id: 'C', desc: 'Yogi ODM/Retret Bhante Kondanna (Di Luar KSN)'},
    ]
  : [
      {id: 'A', desc: 'Yogi ODM Bhante Kondanna (KSN)'},
      {id: 'A', desc: 'Yogi Retreat Bhante Kondanna (KSN)'},
      {id: 'B', desc: 'Volunteer KSN'},
      {id: 'C', desc: 'Yogi ODM/Retreat Bhante Kondanna (Outside KSN)'},
    ];

  const [questions, setQuestions] = useState([
    { checked: false, year: '', id: null },
    { checked: false, year: '', id: null },
    { checked: false, year: '', id: null },
    { checked: false, year: '', id: null },
  ]);  

  const handleClose = () => {
    setShowMessageModal(false);
    navigate("/");
  };

  const handleToggleLanguage = () => {
    setLanguage((prev) => (prev === "ID" ? "EN" : "ID"));
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: currentYear - 2010 }, (_, i) => {
    const year = (2011 + i).toString();
    return { label: year, value: year };
  });

  const handleCheckboxChange = (index, id) => {
    const updated = [...questions];
    updated[index].checked = !updated[index].checked;
    updated[index].id = id;
    if (!updated[index].checked) {
      updated[index].year = '';
      updated[index].id = null;
    }
    setQuestions(updated);
  };

  const handleYearChange = (index, value) => {
    const updated = [...questions];
    updated[index].year = value;
    setQuestions(updated);
  };

  const isValid = questions.filter(x=> x.checked && x.year === "").length === 0;
  const handleNext = () => {
    if(!isValid)
      setTouchedYear(true);
    else
      setPage(2);
  };

  const handleSubmit = () => {
    var checkedQuestion = questions.filter(x=> x.checked).sort((a, b) => a.year - b.year);
    if (declarationChecked && checkedQuestion.length > 0) {
      navigate(`/register/${checkedQuestion[0].id}`);
    }
    else{
      setShowMessageModal(true);
    }
  };
  
  return (
    <div className="questioner-modal-overlay">
      <div className="questioner-modal">
        <div className="questioner-modal-header">
          <LanguageToggle lang={language} onToggle={handleToggleLanguage}/>
          <button onClick={handleClose} className="global-icon questioner-close-button">
            <FaTimes />
          </button>
        </div>
        <div className="progress-container">
          <div
            className={`progress-step ${page === 1 ? "active" : ""} progress-step-1`}
            onClick={() => setPage(1)}
          >
            1
          </div>
          <div className="progress-line" />
          <div
            className={`progress-step ${page === 2 ? "active" : ""}`}
            // onClick={() => setPage(2)}
          >
            2
          </div>
        </div>
        <div className="questioner-modal-content">
          {page === 1 && (
            <>
              <h2 className="modal-title">
                {t("Apakah pernah mengikuti kegiatan berikut ini?","Have you participated in the following activities?")}
              </h2>
              <div className="questioner-checkbox-list">
                {questions.map((item, index) => (
                  <div key={index}>
                    <CustomFormGroup
                        type="checkbox"
                        checked={item.checked}
                        onChange={() => handleCheckboxChange(index, questionsText[index].id)}
                        label={questionsText[index].desc}
                    />
                    {item.checked && (
                      <CustomFormGroup
                        label={t("Tahun", "Year")}
                        name={`year-${index}`}
                        type="select"
                        value={item.year}
                        onChange={(e) => handleYearChange(index, e.target.value)}
                        options={yearOptions}
                        icon={<FaCalendarDay />}
                        placeholder={"-- " + t("Tahun", "Year") + " --"}
                        error={touchedYear && t("Pilih Tahun", "Please Choose Year")}
                      />
                    )}
                  </div>
                ))}
              </div>
              
              <CommonButton onClick={handleNext}>{t("Berikutnya","Next")}</CommonButton>
            </>
          )}
          {page === 2 && (
            <div className="step-content">
            <h2>{t('Pernyataan','Declaration')}</h2>
            <ul>
              <li>{t('Beragama Buddha','Buddhist')}</li>
              <li>{t('Tidak bermasalah dengan hukum','No legal issues')}</li>
              <li>{t('Berusia minimal 17 tahun','Minimum 17 years old')}</li>
            </ul>
            <CustomFormGroup
                type="checkbox"
                checked={declarationChecked}
                onChange={() => setDeclarationChecked(prev => !prev)}
                label={t('Saya menyatakan bahwa pernyataan di atas adalah benar.','I declare that the statements above are true.')}
            />
            <CommonButton onClick={handleSubmit} disabled={!declarationChecked}>Submit</CommonButton>
          </div>
          )}
        </div>

        {showMessageModal && (
          <MessageModal 
            onClose={handleClose} 
            title={t('Mohon Maaf', 'Sorry')}
            message_header={t(
                        'Anda belum memenuhi syarat untuk melanjutkan pendaftaran.',
                        'You do not meet the requirements to proceed with the registration.'
                      )}  
            message_content={
              <div className='questioner-message-modal-left'>
                <p>{t("Untuk dapat menjadi anggota, silahkan berpartisipasi dalam kegiatan berikut:", "To become a member, please participate in the following activities:")}</p>
                <ul>
                  {questionsText.map((item, index) => (<li key={index}>{item.desc}</li>))}
                </ul>
              </div>
            }
            icon={<FaFrown/>}
            button_name={t('Tutup', 'Close')}     
          />
        )}
      </div>
    </div>
  );
};

export default QuestionerModal;
